import { Link } from "react-router-dom";
import { MapPin, Zap } from "lucide-react";
import { SERVICES } from "@/data/services";
import { VoltLogo } from "./Header";

const Footer = () => (
  <footer data-testid="site-footer" className="cv-auto relative overflow-hidden border-t border-cyan-500/10 bg-[#F1F5F9]">
    <div className="mx-auto max-w-7xl px-5 pb-10 pt-16 lg:px-10">
      <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <VoltLogo />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-500">
            High-voltage software engineering studio. Custom software, SaaS, mobile apps, AI agents, and legacy modernization.
          </p>
          <p className="mt-5 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
            <MapPin className="h-3.5 w-3.5 text-cyan-500" /> Lincolnton, North Carolina
          </p>
          <p className="mt-2 flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-600">
            <Zap className="h-3.5 w-3.5 text-cyan-600" /> Engineered in NC. Deployed worldwide.
          </p>
        </div>

        <div>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-500">Services</p>
          <ul className="space-y-2.5">
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`footer-service-${s.slug}`}
                  className="text-sm text-slate-400 transition-colors duration-200 hover:text-cyan-300"
                >
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-500">Studio</p>
          <ul className="space-y-2.5">
            <li><Link to="/#process" data-testid="footer-process" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Our Process</Link></li>
            <li><Link to="/#about" data-testid="footer-about" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">About Volt</Link></li>
            <li><Link to="/insights" data-testid="footer-insights" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Insights</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-sm text-slate-400 transition-colors hover:text-cyan-300">Start a Project</Link></li>
          </ul>
        </div>

        <div>
          <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.25em] text-cyan-500">Engage</p>
          <p className="text-sm leading-relaxed text-slate-500">
            Every engagement starts with a written proposal. Tell us what you're building through the quote form — we reply within one business day.
          </p>
          <Link
            to="/contact"
            data-testid="footer-quote-btn"
            className="mt-5 inline-flex items-center gap-2 rounded-full border border-cyan-400/30 bg-cyan-400/5 px-5 py-2.5 font-display text-sm font-semibold text-cyan-300 transition-all duration-300 hover:border-cyan-400/70 hover:bg-cyan-400/10"
          >
            Request a Quote
          </Link>
        </div>
      </div>

      <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-cyan-500/10 pt-6 sm:flex-row sm:items-center">
        <p className="font-mono text-xs text-slate-600">© {new Date().getFullYear()} volt.software — Lincolnton, NC</p>
        <p className="font-mono text-xs text-slate-600">Built at full voltage.</p>
      </div>
    </div>

    <div aria-hidden="true" className="pointer-events-none select-none px-2 pb-2">
      <div className="stroke-text text-center font-display text-[19vw] font-black leading-[0.8] tracking-tight">VOLT.</div>
    </div>
  </footer>
);

export default Footer;
